import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import goalHeroImage from '../../../assets/images/registration-goal-hero.png';
import { rubikTypographyStyles } from '../../../shared/ui';

const Hero = styled.div.attrs({
  'data-ui': 'registration-goals-goal-intro-hero',
})`
  width: ${({ theme }) => theme.scale.px(329)};
  height: ${({ theme }) => theme.scale.px(187)};
  position: relative;
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const WeddingExample = styled.p`
  ${rubikTypographyStyles};
  width: ${({ theme }) => theme.scale.px(91)};
  margin: 0;
  position: absolute;
  top: ${({ theme }) => theme.scale.px(60)};
  left: ${({ theme }) => theme.scale.px(10)};
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 500;
  line-height: 1.1;
  white-space: pre-line;
  transform: rotate(-15.92deg);
  transform-origin: top left;
`;

const PhoneExample = styled.p`
  ${rubikTypographyStyles};
  width: ${({ theme }) => theme.scale.px(103)};
  margin: 0;
  position: absolute;
  top: ${({ theme }) => theme.scale.px(77)};
  right: ${({ theme }) => theme.scale.px(5)};
  text-align: right;
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 500;
  line-height: 1.1;
  white-space: pre-line;
  transform: rotate(19.81deg);
  transform-origin: top left;
`;

export function GoalIntroHero() {
  const { t } = useTranslation();

  return (
    <Hero>
      <HeroImage alt="" aria-hidden src={goalHeroImage} />
      <WeddingExample>{t('registrationGoals.exampleWedding')}</WeddingExample>
      <PhoneExample>{t('registrationGoals.examplePhone')}</PhoneExample>
    </Hero>
  );
}
